<template>
	<div slot="header">
		<div class="row">
			<div class="col-md-6 col-sm-12 col-12">
				<h4>{{View_Title}}</h4>
			</div>
			<div class="col-md-6 col-sm-12 col-12">
				<button
					type="button"
					class="btn btn-sm btn-danger float-right m-1"
					@click="$emit('delete_clicked')"
					:disabled="IS_DELETE_ALLOWED === false || FORM_LOADING === true || FORM_MODE !== 'R'"
					v-if="IS_DELETE_HIDDEN !== true"
				>
					<i class="fa fa-trash-o fa-fw fa-lg"></i> Delete
				</button>
				<button
					type="button"
					class="btn btn-sm btn-primary float-right m-1"
					@click="$emit('edit_clicked')"
					:disabled="IS_EDIT_ALLOWED === false || FORM_LOADING === true || FORM_MODE !== 'R'"
					v-if="IS_EDIT_HIDDEN !== true"
				>
					<i class="fa fa-edit fa-fw fa-lg"></i> Edit
				</button>
				<button
					type="button"
					class="btn btn-sm btn-primary float-right m-1"
					@click="$emit('new_clicked')"
					:disabled="IS_NEW_ALLOWED === false || FORM_LOADING === true || FORM_MODE !== 'R'"
				>
					<i class="fa fa-plus fa-fw fa-lg"></i> New
				</button>
				<button v-for="(button, key) in Buttons" v-bind:key="key"
					type="button"
					class="btn btn-sm float-right m-1"
					:class="button.class"
					@click="$emit('custom_button_clicked', { button_name: button.name})"
					:disabled="button.allowed === false || FORM_LOADING === true || FORM_MODE !== 'R'"
					>
					<i class="fa fa-fw fa-lg" :class="button.icon"></i> {{button.text}}
				</button>
				<button
					type="button"
					class="btn btn-sm btn-outline-info float-right m-1"
					@click="$emit('backtolist_clicked')"
					v-if="IS_BACK_HIDDEN !== true"
				>
					<i class="fa fa-arrow-circle-left fa-fw fa-lg"></i> Back
				</button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
  name: "DataFormHeader",
  props: {
    FORM_LOADING: Boolean,
    FORM_MODE: String,
	View_Title: String,
	IS_NEW_ALLOWED: Boolean,
	IS_EDIT_ALLOWED: Boolean,
	IS_DELETE_ALLOWED: Boolean,
	Buttons: Array,
	
	IS_EDIT_HIDDEN: Boolean,
	IS_DELETE_HIDDEN: Boolean,
	IS_BACK_HIDDEN: Boolean
  }
}
</script>
